export class ResponseError extends Error {
    public name = 'ResponseError';
}
